<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>ACTUALIZAR CONTRASEÑA:</h1>
            <div class="title-lists">
                {{ selectedProfile?.username }} -
                {{ selectedProfile?.first_name }}
                {{ selectedProfile?.last_name }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editPasswordForm" (ngSubmit)="updatePassword()">
                <div class="line">
                    <div class="column-md-12 column-lg-12 column-sm-15">
                        <mat-form-field appearance="outline">
                            <mat-label>Nueva contraseña</mat-label>
                            <input
                                type="password"
                                minlength="4"
                                matInput
                                name="password"
                                id="password"
                                required
                                formControlName="password"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editPasswordForm
                                        .get('password')
                                        ?.hasError('required')
                                "
                                >Campo obligatorio</mat-error
                            >
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editPasswordForm
                                        .get('password')
                                        ?.hasError('minlength')
                                "
                                >La contraseña debe tener mínimo 4 letras y/o
                                números</mat-error
                            >
                        </mat-form-field>
                        <div class="password-mismatch-error-container">
                            <small
                                class="password-mismatch-error"
                                *ngIf="showPasswordMatchError && editPasswordForm.errors?.['notSame']"
                            >
                                Las contraseñas no coinciden. Intentelo de nuevo
                            </small>
                        </div>
                    </div>

                    <div class="column-md-12 column-lg-12 column-sm-15">
                        <mat-form-field appearance="outline">
                            <mat-label>Confirmar contraseña</mat-label>
                            <input
                                type="password"
                                minlength="4"
                                matInput
                                name="confirmPassword"
                                id="confirmPassword"
                                required
                                formControlName="confirmPassword"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editPasswordForm
                                        .get('confirmPassword')
                                        ?.hasError('required')
                                "
                                >Campo obligatorio</mat-error
                            >
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editPasswordForm
                                        .get('confirmPassword')
                                        ?.hasError('minlength')
                                "
                                >La contraseña debe tener mínimo 4 letras y/o
                                números</mat-error
                            >
                        </mat-form-field>
                        <div class="password-mismatch-error-container">
                            <small
                                class="password-mismatch-error"
                                *ngIf="showPasswordMatchError && editPasswordForm.errors?.['notSame']"
                            >
                                Las contraseñas no coinciden. Intentelo de nuevo
                            </small>
                        </div>
                    </div>
                </div>
                <br />
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"
                        ><mat-icon>save</mat-icon>Guardar</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
